var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:[
    'footer',
    _vm.short ? 'footer--short' : '' ]},[(!_vm.short)?_c('section',{staticClass:"footer__section footer__section--info"},[_c('div',{ref:"sphere",staticClass:"footer__sphere"},[_c('AppHeadline',{attrs:{"data":{
          content: 'Qualify',
          type: 2,
        }}})],1),_c('AppParagraph',{ref:"text",attrs:{"data":{
        content: 'Finish the intro<br>and<br>visit our website'
      }}}),_c('span',{ref:"line",staticClass:"section__line"}),_c('AppButton',{ref:"button",attrs:{"data":{
        content: 'Visit Website'
      }}})],1):_vm._e(),_c('ul',{ref:"voices",staticClass:"footer__section footer__section--links"})])}
var staticRenderFns = []

export { render, staticRenderFns }